define(function (require) {
    "use strict";

    var LE = require("app");
    var ApiResources = require("assets/data/apiResources.json");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var DataSourcesTagletModel = require("manager-models/DataSourcesTagletModel");

    var DataSourcesTagletCollection = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesTagletCollection = RevisionedCollection.extend({
            model : DataSourcesTagletModel,
            resource: ApiResources.AccountConfig.LpTag,
            initialize: function(models, options) {
                LEManager.logger.debug("DataSourcesTagletCollection:initialize - started");
                RevisionedCollection.prototype.initialize.call(this,models,options);
            },

            parse: function(response) {
                // If no response, return an empty array
                if(_.isUndefined(response)) {
                    return [];
                } else {
                    return response.acApp;
                }
            },

            getById: function(id){
                return this.get(id);
            },
            getTagletModel: function(){
                return this.at(0);
            }

        });
    });

    return DataSourcesTagletCollection;
});
